// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"68":"5a23905bac293fc0","5148":"02915ba8c8ca5ca9"}[chunkId] + ".css";
};